/*
  Cinema — open the desktop header dropdown on hover instead of on click.

  Dawn builds that dropdown out of <details>/<summary> wrapped in a <header-menu>
  custom element, so it is the browser's own click-to-toggle. There is no CSS-only
  way to convert it: a closed <details> hides its contents through the UA
  stylesheet, and CSS cannot set the `open` attribute. So this sets it.

  Nothing is replaced. The attribute is the same one the native toggle sets, which
  means the `toggle` event still fires and HeaderMenu.onToggle still runs — that is
  what sets `header.preventHide`, keeping the sticky header from sliding away while
  a menu is open. StickyHeader.closeMenuDisclosure() and DetailsDisclosure's
  focusout handler both keep working untouched, and removing the one loader line
  in snippets/header-dropdown-menu.liquid puts the click behaviour back.

  Three things it is careful about:

  - FINE POINTERS ONLY. On a touch screen there is no hover, and a hover menu
    there eats the first tap. Guarded by `(hover: hover) and (pointer: fine)`,
    re-read on every event rather than cached, so a 2-in-1 that switches between
    touch and trackpad gets the right behaviour without a reload.

  - CLICK MUST NOT CLOSE IT. Once hover has opened the panel, the pointer is by
    definition over the summary, so a click would toggle it shut again — the menu
    would flicker closed under the cursor. Real pointer clicks are suppressed;
    keyboard activation is not. `event.detail` is the discriminator: a mouse click
    carries a click count of 1 or more, while Enter or Space on a focused summary
    dispatches a synthetic click with detail 0. So keyboard users keep the toggle.

  - A CLOSE DELAY. The panel's top edge meets the summary's bottom edge exactly,
    so there is no dead gap straight down, but a diagonal exit clips the corner and
    fires mouseleave. 120ms of grace absorbs that and is short enough not to feel
    sticky. The timer also stands down if focus is inside the menu, so a keyboard
    user tabbing through the links is not closed on by a stray mouse movement.
*/
(function () {
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 120;

  function wire(headerMenu) {
    if (headerMenu.dataset.cinemaHover === '1') return;
    var details = headerMenu.querySelector('details');
    if (!details) return;
    headerMenu.dataset.cinemaHover = '1';

    var summary = details.querySelector('summary');
    var timer = null;

    function open() {
      clearTimeout(timer);
      if (!FINE.matches || details.hasAttribute('open')) return;
      details.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    function close() {
      clearTimeout(timer);
      if (!FINE.matches || !details.hasAttribute('open')) return;
      timer = setTimeout(function () {
        if (headerMenu.contains(document.activeElement)) return;
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }

    /* mouseenter/mouseleave rather than mouseover/mouseout: they do not bubble,
       so moving between the summary and the rows inside the panel does not churn.
       The panel is absolutely positioned but is still a DOM descendant of
       <details>, and these events go by the DOM tree rather than by geometry, so
       hovering the panel counts as hovering the menu. */
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);

    if (summary) {
      summary.addEventListener('click', function (event) {
        if (FINE.matches && event.detail > 0) event.preventDefault();
      });
    }
  }

  function bind(root) {
    var menus = (root || document).querySelectorAll('.header__inline-menu header-menu');
    for (var i = 0; i < menus.length; i++) wire(menus[i]);
  }

  bind();
  /* The theme editor re-renders the header section in place, which throws away
     the listeners above. The dataset flag is thrown away with them, so re-binding
     is safe and never doubles up. */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target);
  });
})();
